<svg
  *ngIf="selectedIcon === 'unplugged'"
  xmlns="http://www.w3.org/2000/svg"
  width="20"
  height="20"
  viewBox="0 0 20 20"
  fill="none"
>
  <mask
    id="mask0_1127_926"
    style="mask-type: alpha"
    maskUnits="userSpaceOnUse"
    x="0"
    y="0"
    width="20"
    height="20"
  >
    <rect width="20" height="20" fill="#D9D9D9" />
  </mask>
  <g mask="url(#mask0_1127_926)">
    <path
      d="M7.9165 17.5V15L4.99984 12.0834V7.50004C4.99984 7.16671 5.07623 6.85421 5.229 6.56254C5.38178 6.27087 5.604 6.04865 5.89567 5.89587L7.49984 7.50004H6.6665V11.375L9.58317 14.2917V15.8334H10.4165V14.2917L11.1873 13.5209L1.1665 3.50004L2.33317 2.33337L17.6665 17.6667L16.4998 18.8334L12.3748 14.7084L12.0832 15V17.5H7.9165ZM14.2915 11.9167L13.3332 10.9584V7.50004H9.87484L6.6665 4.29171V2.50004H8.33317V5.83337H11.6665V2.50004H13.3332V6.66671L12.4998 5.83337H13.3332C13.7915 5.83337 14.1839 5.99657 14.5103 6.32296C14.8366 6.64935 14.9998 7.04171 14.9998 7.50004V11.2084L14.2915 11.9167Z"
      fill="#002987"
    />
  </g>
</svg>
<svg
  *ngIf="selectedIcon === 'charging'"
  xmlns="http://www.w3.org/2000/svg"
  width="24"
  height="24"
  viewBox="0 0 24 24"
  fill="none"
>
  <mask
    id="mask0_809_940"
    style="mask-type: alpha"
    maskUnits="userSpaceOnUse"
    x="0"
    y="0"
    width="24"
    height="24"
  >
    <rect width="24" height="24" fill="#D9D9D9" />
  </mask>
  <g mask="url(#mask0_809_940)">
    <path
      d="M11.3 20L16.3 10.25H12.8V4L7.8 13.75H11.3V20ZM12 22C10.6167 22 9.31667 21.7375 8.1 21.2125C6.88333 20.6875 5.825 19.975 4.925 19.075C4.025 18.175 3.3125 17.1167 2.7875 15.9C2.2625 14.6833 2 13.3833 2 12C2 10.6167 2.2625 9.31667 2.7875 8.1C3.3125 6.88333 4.025 5.825 4.925 4.925C5.825 4.025 6.88333 3.3125 8.1 2.7875C9.31667 2.2625 10.6167 2 12 2C13.3833 2 14.6833 2.2625 15.9 2.7875C17.1167 3.3125 18.175 4.025 19.075 4.925C19.975 5.825 20.6875 6.88333 21.2125 8.1C21.7375 9.31667 22 10.6167 22 12C22 13.3833 21.7375 14.6833 21.2125 15.9C20.6875 17.1167 19.975 18.175 19.075 19.075C18.175 19.975 17.1167 20.6875 15.9 21.2125C14.6833 21.7375 13.3833 22 12 22ZM12 20C14.2167 20 16.1042 19.2208 17.6625 17.6625C19.2208 16.1042 20 14.2167 20 12C20 9.78333 19.2208 7.89583 17.6625 6.3375C16.1042 4.77917 14.2167 4 12 4C9.78333 4 7.89583 4.77917 6.3375 6.3375C4.77917 7.89583 4 9.78333 4 12C4 14.2167 4.77917 16.1042 6.3375 17.6625C7.89583 19.2208 9.78333 20 12 20Z"
      fill="#26b41b"
    />
  </g>
</svg>
<svg
  *ngIf="selectedIcon === 'paused'"
  width="20"
  height="20"
  viewBox="0 0 20 20"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <rect x="6.5" y="5" width="2" height="10" fill="#002987" />
  <rect x="11.5" y="5" width="2" height="10" fill="#002987" />
</svg>
<svg
  *ngIf="selectedIcon === 'unreachable'"
  xmlns="http://www.w3.org/2000/svg"
  width="20"
  height="20"
  viewBox="0 0 20 20"
  fill="none"
>
  <mask
    id="mask0_1129_9495"
    style="mask-type: alpha"
    maskUnits="userSpaceOnUse"
    x="0"
    y="0"
    width="20"
    height="20"
  >
    <rect width="20" height="20" fill="#D9D9D9" />
  </mask>
  <g mask="url(#mask0_1129_9495)">
    <path
      d="M16.4583 18.8335L8.625 10.9585C7.97222 11.1113 7.36458 11.3404 6.80208 11.646C6.23958 11.9516 5.73611 12.3335 5.29167 12.7918L3.54167 11.0002C3.98611 10.5557 4.46528 10.1668 4.97917 9.8335C5.49306 9.50016 6.04167 9.2085 6.625 8.9585L4.75 7.0835C4.18056 7.37516 3.64931 7.69808 3.15625 8.05225C2.66319 8.40641 2.19444 8.80572 1.75 9.25016L0 7.4585C0.444444 7.01405 0.90625 6.61475 1.38542 6.26058C1.86458 5.90641 2.375 5.56961 2.91667 5.25016L1.16667 3.50016L2.33333 2.3335L17.6667 17.6668L16.4583 18.8335ZM10 17.5002C9.41667 17.5002 8.92361 17.2953 8.52083 16.8856C8.11806 16.4759 7.91667 15.9863 7.91667 15.4168C7.91667 14.8335 8.11806 14.3404 8.52083 13.9377C8.92361 13.5349 9.41667 13.3335 10 13.3335C10.5833 13.3335 11.0764 13.5349 11.4792 13.9377C11.8819 14.3404 12.0833 14.8335 12.0833 15.4168C12.0833 15.9863 11.8819 16.4759 11.4792 16.8856C11.0764 17.2953 10.5833 17.5002 10 17.5002ZM14.9167 12.5418L10.7083 8.3335C11.8333 8.44461 12.8854 8.72933 13.8646 9.18766C14.8438 9.646 15.7083 10.2502 16.4583 11.0002L14.9167 12.5418ZM18.25 9.25016C17.1806 8.18072 15.941 7.34391 14.5312 6.73975C13.1215 6.13558 11.6111 5.8335 10 5.8335C9.70833 5.8335 9.42708 5.84391 9.15625 5.86475C8.88542 5.88558 8.61111 5.91683 8.33333 5.9585L6.20833 3.8335C6.81944 3.66683 7.44097 3.54183 8.07292 3.4585C8.70486 3.37516 9.34722 3.3335 10 3.3335C11.9722 3.3335 13.8125 3.70155 15.5208 4.43766C17.2292 5.17377 18.7222 6.18072 20 7.4585L18.25 9.25016Z"
      fill="#002987"
    />
  </g>
</svg>
<svg
  *ngIf="selectedIcon === 'loading'"
  xmlns="http://www.w3.org/2000/svg"
  width="20"
  height="20"
  viewBox="0 0 20 20"
  fill="none"
>
  <mask
    id="mask0_903_8336"
    style="mask-type: alpha"
    maskUnits="userSpaceOnUse"
    x="0"
    y="0"
    width="20"
    height="20"
  >
    <rect width="20" height="20" fill="#D9D9D9" />
  </mask>
  <g mask="url(#mask0_903_8336)">
    <path
      d="M10.0418 16.6666C8.18072 16.6666 6.59739 16.0208 5.29183 14.7291C3.98627 13.4374 3.3335 11.861 3.3335 9.99992V9.85409L2.00016 11.1874L0.833496 10.0208L4.16683 6.68742L7.50016 10.0208L6.3335 11.1874L5.00016 9.85409V9.99992C5.00016 11.3888 5.48975 12.5694 6.46891 13.5416C7.44808 14.5138 8.63905 14.9999 10.0418 14.9999C10.4029 14.9999 10.7571 14.9583 11.1043 14.8749C11.4516 14.7916 11.7918 14.6666 12.1252 14.4999L13.3752 15.7499C12.8474 16.0555 12.3057 16.2846 11.7502 16.4374C11.1946 16.5902 10.6252 16.6666 10.0418 16.6666ZM15.8335 13.3124L12.5002 9.97908L13.6668 8.81242L15.0002 10.1458V9.99992C15.0002 8.61103 14.5106 7.43047 13.5314 6.45825C12.5522 5.48603 11.3613 4.99992 9.9585 4.99992C9.59739 4.99992 9.24322 5.04159 8.896 5.12492C8.54877 5.20825 8.2085 5.33325 7.87516 5.49992L6.62516 4.24992C7.15294 3.94436 7.69461 3.7152 8.25016 3.56242C8.80572 3.40964 9.37516 3.33325 9.9585 3.33325C11.8196 3.33325 13.4029 3.97909 14.7085 5.27075C16.0141 6.56242 16.6668 8.13881 16.6668 9.99992V10.1458L18.0002 8.81242L19.1668 9.97908L15.8335 13.3124Z"
      fill="#002987"
    />
  </g>
</svg>
